import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Temoignages.css';

// Composant pour afficher les étoiles
const Etoiles = ({ note }) => {
  const etoiles = [];
  for (let i = 1; i <= 5; i++) {
    etoiles.push(
      <span key={i} className={i <= note ? 'etoile remplie' : 'etoile'}>
        ★
      </span>
    );
  }
  return <div className="etoiles-container">{etoiles}</div>;
};

const Temoignages = () => {
  const temoignages = [
    {
      texte: "Au top !!! N’hésitez pas, les frites sont délicieuses et servies dans la joie et la bonne humeur !!!",
      auteur: "Laura M.",
      note: 4
    },
    {
      texte: "Merci aux Tontons Friteurs pour avoir fait le repas à mon anniversaire !! Tous les invités se sont régalés et le services a été de très bonne qualité ! Je recommande vivement ",
      auteur: "Matt D.",
      note: 5
    },
    {
      texte: "J'ai été hier avec mes deux petits garçons à la braderie de Mouvaux, il on été super généreux 😉 et vraiment au top, de super bon commerçant, super accueillent, et très bon dialogue. 🥰 Encore merci pour tout.",
      auteur: "Alexandra G.",
      note: 4
    },
    {
      texte: "Prestation ce midi pour notre société ! L’ensemble du personnel était satisfait ! Une réussite ☺️☺️ Merci beaucoup pour votre service,gentillesse! A très vite",
      auteur: "Audrey H.",
      note: 5
    },
    {
      texte: "Une belle rencontre ce week-end. Mélanie nous parle avec passion de son métier, elle a le cœur sur la main. Une belle personne qui mérite d'être connue. Merci Mélanie pour ce moment partagé",
      auteur: "Séverine C.",
      note: 5
    }
  ];

  // Configuration du carousel
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    arrows: true
  };

  return (
    <section id="temoignages" className="temoignages-section">
      <h2 className="section-title2">Ils nous font confiance</h2>
      <div className="temoignages-carousel">
        <Slider {...settings}>
          {temoignages.map((temoignage, index) => (
            <div key={index} className="temoignage-slide">
              <div className="temoignage-card">
                <p className="temoignage-texte">"{temoignage.texte}"</p>
                <Etoiles note={temoignage.note} />
                <p className="temoignage-auteur">— {temoignage.auteur}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Temoignages;
